import React from 'react';
import {
  Box,
  Tabs,
  Tab,
  Grid,
} from '@mui/material';
import { DataLoggerDetails } from '../hooks/useDataLoggerDetails';
import { SensorConfig } from '../hooks/useCreateOrUpdateDataLogger';
import ConfigurationDialogFirstTab from './ConfigurationDialogFirstTab';
import ConfigurationDialogSecondTab from './ConfigurationDialogSecondTab';
import { Primary } from '../../../core-components/theme/color-palette/colors';



interface ConfigurationDialogTabsProps {
  activeTab: number;
  formData: Partial<DataLoggerDetails>;
  sensorConfigs: { [key: string]: SensorConfig };
  expandedSensors: string[];
  isFirstTabComplete: boolean;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  onInputChange: (field: string, value: any) => void;
  onAssetChange: (asset: any) => void;
  onSensorConfigChange: (sensorId: string, field: string, value: any) => void;
  onSensorToggle: (sensorId: string) => void;
  onSensorSelect: (sensor: any) => void;
  onSensorRemove: (sensorId: string) => void;
  onNext: () => void;
  errors: { [key: string]: string };
  setErrors: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
  initialData?: {
    serialNumber?: string;
    id?: string;
  };
  sensorConfigErrors: { [sensorId: string]: { [field: string]: string } };
}

export default function ConfigurationDialogTabs({
  activeTab,
  formData,
  sensorConfigs,
  expandedSensors,
  isFirstTabComplete,
  onTabChange,
  onInputChange,
  onAssetChange,
  onSensorConfigChange,
  onSensorToggle,
  onSensorSelect,
  onSensorRemove,
  onNext,
  errors,
  setErrors,
  initialData,
  sensorConfigErrors,
}: ConfigurationDialogTabsProps) {
  const handleTabChangeWithValidation = (event: React.SyntheticEvent, newValue: number) => {
    onTabChange(event, newValue);
  };
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', position: 'sticky', top: 0, zIndex: 2, background: '#fff' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChangeWithValidation}
          aria-label="DataLogger configuration tabs"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: Primary[700],
            },
          }}
        >
          <Tab
            label="DataLogger Details"
            sx={{
              color: Primary[700],
              '&.Mui-selected': {
                color: Primary[700],
              },
            }}
          />
          <Tab
            label="Sensor Configuration"
            disabled={!isFirstTabComplete}
            sx={{
              color: Primary[700],
              '&.Mui-selected': {
                color: Primary[700],
              },
            }}
          />
        </Tabs>
      </Box>

      <Box sx={{ p: 3 }}>
        {activeTab === 0 && (
          <Grid container spacing={3}>
            <ConfigurationDialogFirstTab
              formData={formData}
              errors={errors}
              setErrors={setErrors}
              onInputChange={onInputChange}
              onAssetChange={onAssetChange}
              initialData={initialData}
            />
          </Grid>
        )}

        {activeTab === 1 && (
          <Grid container spacing={3}>
            <ConfigurationDialogSecondTab
              formData={formData}
              sensorConfigs={sensorConfigs}
              expandedSensors={expandedSensors}
              onSensorConfigChange={onSensorConfigChange}
              onSensorToggle={onSensorToggle}
              onSensorSelect={onSensorSelect}
              onSensorRemove={onSensorRemove}
              errors={errors}
              sensorConfigErrors={sensorConfigErrors}
            />
          </Grid>
        )}
      </Box>
    </Box>
  );
} 